import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserLight } from '../../users-module/models/userLight';
import { ClientLocation } from '../../clients-module/models/clientLocation';
import { Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from '../../clients-module/services/client.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { DatePipe } from '@angular/common';
import { ObjectUpdatePayload, ScreeningLight } from '../../models/screeningInvite';
import { SearchPackage } from '../../packages-module/models/searchPackage';
import { ValidationService } from '../../services/validation.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { PropertyService } from '../services/property.service';
import { UserService } from 'src/app/users-module/services/user.service';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-properties-stats',
  templateUrl: './properties-stats.component.html',
  styleUrls: ['./properties-stats.component.less']
})
export class PropertiesStatsComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    if(this.sub)this.sub.unsubscribe();
  
  }
  addingPackages: boolean = false;
  propertyUsers: Array<UserLight>;
  filtersApplied: boolean;
  activeClientLocation : ClientLocation;
  showUsers: boolean = false;
  showPackages: boolean = false;
  showProperties: boolean = false;
  showScreenings: boolean = false;
  showIQSettings: boolean = false;
  showNotes: boolean = true;
  showClientInfo: boolean = false;
  listner$: Subject<any>;
  sub: Subscription;
  error: boolean;
  clientId: number;
  propertyId: number;
  validatorType : string = "PropertyStats";
  passingValidation: boolean;
  public activeId: number = 1;

  public lockModelInputs: boolean = true;

  def: NgbNav;

  currentPage: number = 0;
  pageIncrement: number = 30;
  pageIncrements: any[] = ['10', '30', '50', '100', '200'];

  constructor(public toastr: ToastrService,
    public datePipe: DatePipe,
    public screening: ScreeningService,
    public auth: AuthService,
    public location: Router,
    public activatedRoute: ActivatedRoute,
    public clients: ClientService,
    public toast: ToastrService,
    public validator: ValidationService,
    public properties: PropertyService,
    public filtering : FilteringService, 
    public users : UserService) {

  }


  public editProperty() {
    this.location.navigateByUrl(`properties/edit/${this.propertyId}/${this.clientId}`);
  }

  viewUser(c: UserLight) {
    this.location.navigateByUrl(`users/review/${c.id}/${this.clients.currentClient.id}`);
  }

  viewUser2(c: number) {
    this.location.navigateByUrl(`users/review/${c}/${this.clients.currentClient.id}`);
  }

  update(val: any) {
    this.validator.removeValidation(val.name);
    if (this.activeClientLocation[val.name] != val.value) {
      this.activeClientLocation[val.name] = val.value;
    }
   
  }

  newUser() {
    this.location.navigateByUrl(`/users/new/${this.clientId}`)
  }
  updateThresholds() {
    this.runValidation();
    if (this.validator.invalidFields.length > 0 || !this.passingValidation) {
      return;
    }
    this.properties.UpdateProperty(this.activeClientLocation).subscribe(
      (dta: boolean) => {
        if (dta) {
          this.toastr.success('Client location updated successfully.', 'Update Succeeded!')
        } else {
          this.toastr.error('Client location update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true })
        }
      },
      (err: any) => {
        this.toastr.error('Client location update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true })
      })
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p: ParamMap) => {
      this.clientId = parseInt(p.get('client'));
      this.propertyId = parseInt(p.get('prop'));
      this.properties.FetchMarketSegments();
      this.properties.FetchProperty(this.propertyId).subscribe((res : ClientLocation) => {
        this.activeClientLocation = Object.assign(new ClientLocation(), res);
        this.activeClientLocation.apiPartnerName = this.clients.apiPartner.find(ptn =>{ return ptn.id == this.activeClientLocation.apiPartner;}).name;
      },
      err => this.toast.error('Error fetching property', '', { closeButton: true, disableTimeOut: true }));
    })
  }

  runValidation() {
    if(this.activeClientLocation.conditionalHighVerbiage && this.activeClientLocation.conditionalHighVerbiage.length > 256) {
      this.validator.AddField({
        name : 'conditionalHighVerbiage',
        msg : 'Verbiage exceeds 255 character limit. Current count: ' + this.activeClientLocation.conditionalHighVerbiage.length,
        validator : this.validatorType
      })
      this.passingValidation = false;
    }else{
      this.validator.removeValidation('conditionalHighVerbiage');
      this.passingValidation = true;
    }
  }

  public get marketSegment(): string {
    if(this.properties.marketSegments.length > 0) {
      let seg = this.properties.marketSegments.find(res => { return res.id === this.activeClientLocation.marketSegmentId });
      if(seg) return seg.name;
      else return "";
    } else
    return "";
  }

  viewScreening(scrn: ScreeningLight, setEditState: boolean = false) {
    this.location.navigateByUrl(`screenings/review/${scrn.id}${setEditState ? "/Screening" : ""}`);
  }

  viewPackage(pkg: SearchPackage) {
    this.location.navigateByUrl(`packages/review/${pkg.id}`);
  }
}
